import { render, staticRenderFns } from "./BaseComposableCheckpoint.vue?vue&type=template&id=2f91bd12&scoped=true&"
import script from "./BaseComposableCheckpoint.vue?vue&type=script&lang=js&"
export * from "./BaseComposableCheckpoint.vue?vue&type=script&lang=js&"
import style0 from "./BaseComposableCheckpoint.vue?vue&type=style&index=0&id=2f91bd12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f91bd12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f91bd12')) {
      api.createRecord('2f91bd12', component.options)
    } else {
      api.reload('2f91bd12', component.options)
    }
    module.hot.accept("./BaseComposableCheckpoint.vue?vue&type=template&id=2f91bd12&scoped=true&", function () {
      api.rerender('2f91bd12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/MenuArea/Checkpoints/BaseComposableCheckpoint.vue"
export default component.exports